import { fetchCollections } from '~/js/utilities/products-and-collections';

const matcher = window.matchMedia(`(min-width: 1024px)`);

const productsBrowserFacetsWrapper = () => ({
  isSpecialOpen: false,
  filterCollectionsCache: {},

  get specialFacet() {
    if (this.algoliaFacetsData.gender) {
      return this.algoliaFacetsData.gender;
    }

    return null;
  },

  // get filterSummary() {
  //   return this.data.filterSummary.map((item) => {
  //     let { filterValue } = item;

  //     if (filterValue.startsWith('gid://shopify/Collection/')) {
  //       if (!this.filterCollectionsCache[filterValue]) {
  //         const originalFilterValue = filterValue;
  //         this.filterCollectionsCache[filterValue] = '…';
  //         fetchCollections([filterValue]).then((collections) => {
  //           const collection = collections[originalFilterValue];
  //           this.filterCollectionsCache[originalFilterValue] =
  //             collection?.iconTitle?.value || collection?.title || '…';
  //         });
  //       }
  //       filterValue = this.filterCollectionsCache[filterValue];
  //     }

  //     return {
  //       ...item,
  //       filterValue,
  //     };
  //   });
  // },

  init() {
    this.dialog = this.$el.querySelector('dialog');
    this.append();
    this.handleMediaQuery = this.handleMediaQuery.bind(this);
    matcher.addEventListener('change', this.handleMediaQuery);
  },

  destroy() {
    matcher.removeEventListener('change', this.handleMediaQuery);
  },

  append() {
    // hack to render only once in dom but move around based on media query

    if (matcher.matches) {
      this.dialog.close();
      this.$refs.sidebar.appendChild(this.$refs.facets);
    } else {
      this.$el
        .querySelector('.js-products-browser-facets-wrapper-drawer')
        .appendChild(this.$refs.facets);
    }
  },

  handleMediaQuery() {
    this.append();
  },

  handleMobileOpen() {
    this.dialog.showModal();
  },

  handleDrawerOpen() {
    this.ignoreUpdates = true; // in parent context
  },

  handleDrawerClose() {
    this.ignoreUpdates = false; // in parent context
  },

  async applyFacets() {
    this.instantSearchClient && this.instantSearchClient.refresh();
    this.dialog.close();
  },

  async clearAllFacets() {
    this.dialog.close();
  },

  handleMobileToggleSpecial() {
    this.isSpecialOpen = !this.isSpecialOpen;
  },
});

export default productsBrowserFacetsWrapper;
